import { Center, Img } from '@chakra-ui/react';
import React from 'react';
import Spin from '../images/spin.svg';
import './loading.css';

function LoadingImg() {
  return (
    <Center position="fixed" inset={0} zIndex={1}>
      <Img src={Spin} className="rotate" boxSize="140px" />
    </Center>
  );
}

export default LoadingImg;
